import { Box, Grid } from "@material-ui/core";
import { Championship, durationTypeDescription, RaceConfiguration } from "api";
import { FieldArray } from "formik";
import MaterialTable from "material-table";
import React from "react";
import { RaceConfigurationForm } from "ui/views/ChampionshipForm/RaceConfiguration/RaceConfigurationForm";

interface RaceConfigurationListProps {
    championship: Championship;
    configurations?: RaceConfiguration[];
}

const onAdd = (push) => (raceConfiguration) => {
    push(raceConfiguration);
};

const RaceConfigurationList: React.FC<RaceConfigurationListProps> = ({
    configurations = [],
}) => {
    return (
        <Grid container spacing={1}>
            <FieldArray name="raceConfigurations">
                {({ push, remove }) => (
                    <>
                        <Grid item xs={12}>
                            <RaceConfigurationForm onAdd={onAdd(push)} />
                        </Grid>
                        <Grid item xs={12}>
                            <MaterialTable
                                components={{ Container: Box }}
                                title="Baterias"
                                data={configurations}
                                columns={[
                                    {
                                        field: "tableData.id",
                                        title: "Bateria",
                                        align: "right",
                                        render: (data) =>
                                            data["tableData"]["id"] + 1,
                                    },
                                    {
                                        field: "duration",
                                        title: "Duração",
                                        render: (configuration) =>
                                            `${
                                                configuration.duration
                                            } ${durationTypeDescription(
                                                configuration.durationType
                                            )}`,
                                    },
                                    {
                                        field: "weather",
                                        title: "Clima",
                                    },
                                ]}
                                actions={[
                                    {
                                        icon: "delete",
                                        onClick: (event, configuration) => {
                                            remove(
                                                configuration["tableData"]["id"]
                                            );
                                        },
                                    },
                                ]}
                                options={{
                                    draggable: false,
                                    sorting: false,
                                    toolbar: false,
                                    paging: false,
                                }}
                            />
                        </Grid>
                    </>
                )}
            </FieldArray>
        </Grid>
    );
};

export { RaceConfigurationList };
